import { featureAtom } from "@sunrise/feature-flags";

export const castDirectorEnabledAtom = featureAtom(
  "detail-page-cast-and-director",
  false,
  {
    description: `Feature flag to enable cast and director information on detail pages.`,
  },
);
